module.exports = __webpack_public_path__ + "img/7A7C63_625531_665B3F_5B4B29-256px.abad683d.png";